"use client";

import { Suspense } from "react";
import dynamicImport from "next/dynamic";
import UnifiedMarketplace from "@/components/marketplace/UnifiedMarketplace";

// Prevent static generation - may use client-side data
export const dynamic = 'force-dynamic';

// Dynamically import to ensure client-only rendering (no SSR)
const ClientMarketplace = dynamicImport(() => Promise.resolve(UnifiedMarketplace), {
  ssr: false,
  loading: () => (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-slate-600 dark:text-slate-400">Loading...</div>
    </div>
  ),
});

export default function MarketplacePage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-600 dark:text-slate-400">Loading...</div>
      </div>
    }>
      <ClientMarketplace />
    </Suspense>
  );
}

